import React from "react";
import {
  ReusableOnboardingMapButton,
  ReusableOnboardingButton,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../../store/validation/is-Empty";
import { useHistory } from "react-router";

export const HealthAndSenitationScreenOne = ({
  bigText,
  smallText,
  primaryBigText,
  primarySmallText,
  otherHealth,
  selectedOtherHealth,
  primaryOtherHealth,
  onRestaurantSelectorArraySelector,
  onRestaurantsPrimarySelector,
  displayPrimary,
  removeButton,
  onBackButtonClick,
  onNextButtonClick,
  displayNextButton,
  protocolNext,
  extraClass,
  actionButton,
}) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="restaurant_type_onboarding_main margin-bottom-chains-onboarding">
        <div className="col-12 located-inside-heading-text">
          <h3 className="text-dark">{bigText}</h3>
          {protocolNext === true ? <p>{smallText}</p> : null}
        </div>
        <div>
          <div className="cuisine-main ">
            {protocolNext === true ? (
              <div>
                <div
                  className="cuisine-main-padding"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {otherHealth.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      extraClass={extraClass}
                      onClick={onRestaurantSelectorArraySelector(icon, index)}
                    />
                  ))}
                  <div className="suggest-button-heading">
                    <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d10"} />
                  </div>
                </div>
              </div>
            ) : null}

            {/** */}
            {!isEmpty(selectedOtherHealth) && protocolNext === true ? (
              <h2 className="heading-title">
                {primaryBigText}
                <small
                  id="emailHelp"
                  className="form-text text-muted input-help-textnew"
                >
                  {primarySmallText}
                </small>
              </h2>
            ) : null}

            <div
              className="cuisine-main-padding mt-4"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              {selectedOtherHealth.map((icon, index) => (
                <ReusableOnboardingMapButton
                  key={index}
                  classsection={
                    icon._id === primaryOtherHealth._id
                      ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type m-0"
                      : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active m-0"
                  }
                  src={icon.icon}
                  title={icon.title}
                  displayPrimary={
                    icon._id === primaryOtherHealth._id ? true : false
                  }
                  extraPrimaryStyles={
                    history.location.pathname.includes("edit")
                      ? {
                          marginBottom: "10px",
                          bottom: "0.5px",
                          position: "relative",
                        }
                      : {}
                  }
                  onClick={
                    protocolNext === true
                      ? onRestaurantsPrimarySelector(icon)
                      : null
                  }
                  extraClass={extraClass}
                  displayRemove={protocolNext === true ? true : false}
                  removeButtonClick={removeButton(icon)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="col-12 p-0 d-flex justify-content-between mb-4">
          {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            buttonType="button"
            onClick={onBackButtonClick}
          />
          {protocolNext === true ? (
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={`onboarding_button_link_reusable ${
                errorChecker(selectedOtherHealth, primaryOtherHealth) ||
                actionButton === false
                  ? "onboarding_button_link_reusable_gray"
                  : "onboarding_button_link_reusable_red"
              }`}
              buttonText={"Save"}
              buttonType="button"
              disabled={
                errorChecker(selectedOtherHealth, primaryOtherHealth) ||
                actionButton === false
              }
              onClick={onNextButtonClick}
            />
          ) : null}
          {/* </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

const errorChecker = (selectedOtherHealth, primaryOtherHealth) => {
  if (selectedOtherHealth.length === 0 || isEmpty(primaryOtherHealth)) {
    return true;
  } else {
    return false;
  }
};
